import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'

import { routeIdSelector, fromUaRouteSelector } from 'reduxModules/selectors/RouteSelectors'
import { routeCitiesInfoSelector } from 'reduxModules/selectors/CitySelectors'
import { cityActions } from 'reduxModules/actions/CityActions'

import { RouteManagmentBase } from './RouteManagment'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  routeId: routeIdSelector,
  fromUaRoute: fromUaRouteSelector,
  routeCitiesInfo: routeCitiesInfoSelector,
})

const mapDispatchToProps = {
  updateCityStation: cityActions.updateCityStation,
  setCityStation: cityActions.setCityStation,
  updateCityTime: cityActions.updateCityTime,
  setCityTime: cityActions.setCityTime
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const RouteManagment = enhance(RouteManagmentBase)



// WEBPACK FOOTER //
// ./src/components/RouteManagment/index.js